import { useCallback, useRef } from "react";
var useRestoreFocus = function () {
    var ref = useRef(null);
    var restoreFocusToRef = useCallback(function () { var _a; return (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    return {
        ref: ref,
        restoreFocusToRef: restoreFocusToRef,
    };
};
export default useRestoreFocus;
